import { React, useState } from 'react';
import { makeStyles, useTheme } from '@material-ui/core/styles';
import {
  Grid,
  Box,
  Paper,
  useMediaQuery
} from '@material-ui/core';
import { ROUTES } from '../../../../constants/routes';
import { useHistory } from 'react-router-dom'

export default function SectionThree(props) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.up('md'));
  const isMobileSmall = useMediaQuery(theme.breakpoints.up('md'));
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      fontFamily: 'Raleway',
    },
    sectionStyle: {
      backgroundColor: 'white',
      paddingLeft: 20,
      paddingRight: 20,
      fontSize: '1.2rem',
      color: 'black',
      marginTop: '10px'

    },
    sectionStyleMobile: {
      backgroundColor: 'white',
      fontSize: '.9rem',
      color: 'black',
      marginTop: '10px'

    },
    innerGridContainer: {
      width: "100%",
      margin: "0px",
    },
    innerGridSmallHeading: {
      width: "100%",
      textAlign: "center",
      fontSize: "1rem",
      fontWeight: "bold",
      fontFamily: "sans-serif",
      marginTop: '50px',
      marginBottom: '30px',
    },
    innerGridHeading: {
      width: "100%",
      textAlign: "center",
      fontSize: "3rem",
      fontFamily: "sans-serif",
      marginTop: '50px',
      marginBottom: '30px'
    },
    sectionParagraph: {
      // margin: "10px 0px",
      textAlign: "center",
      fontSize: ".6rem",
      marginTop: '30px',
      fontWeight: 'bold'
    },
    media: {
      maxHeight: 300,
      maxWidth: 700,
      minHeight: 300,
      float: 'right',
      width: '100%'
    },
    
  }));

  const classes = useStyles();
  const history = useHistory();

  return (
    <div className={classes.root}>
      <section className={isMobile ? classes.sectionStyle : classes.sectionStyleMobile}>
        <Grid className={classes.innerGridContainer} container direction="row" justify="center" alignItems="center"
          spacing={5}>
          <Grid item xs={6} sm={6}>
            <h5 className={classes.innerGridHeading} >
              <p style={{ fontWeight: "200", fontSize: "50px" }}>“</p>
              <Grid container direction="row" justify="center" alignItems="center">
                <p style={{
                  fontWeight: "200", textAlign: 'center', marginLeft: isMobile ? '200px' : '0px',
                  marginRight: isMobile ? '140px' : '0px', fontSize: '25px'
                }}>PASSION LEADS TO SUCCESS</p>
              </Grid>
            </h5>
          </Grid>
          <Grid item xs={6} sm={6}>
            <p className={classes.sectionParagraph} style={{ textAlign: 'left', marginRight: isMobile ? '200px' : '0px' }}>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Curabitur in est vel nulla varius aliquet aliquet ac ante. Ut nibh urna, posuere et risus vel, sagittis interdum diam. Nulla vitae luctus metus. Nulla vulputate eros eu purus congue, id blandit ante fringilla. Aenean vehicula, ex eu dignissim tempor, quam lectus dictum lacus, in ultricies nisl velit ut magna. Donec lacus mauris, vulputate aliquet arcu sit amet, maximus convallis leo. Duis pharetra vel ligula a placerat. Pellentesque vitae porttitor metus. Praesent venenatis metus ut consectetur blandit. Praesent vehicula metus nisi, vel finibus velit interdum non. Nunc sed rhoncus sem, et hendrerit nibh. Curabitur vitae massa sapien. Sed nec aliquet ipsum. Phasellus luctus sapien a lorem volutpat, ut egestas nisi viverra.
              Proin porta, est non vulputate finibus, mauris nisi porta quam, ac efficitur augue metus in orci. Quisque eget lorem quis elit gravida fermentum quis vitae nisl. Phasellus suscipit id diam at maximus. Nunc venenatis velit ac urna vehicula, nec accumsan enim pellentesque. Donec laoreet ligula imperdiet velit laoreet porttitor. Nulla in orci eu eros accumsan egestas. Aliquam aliquet est a varius dictum. Aenean sem lectus, volutpat bibendum ornare sed, bibendum sed elit. Pellentesque imperdiet dui eu viverra eleifend. Nunc in tellus leo. Nam finibus felis sed mi vehicula, ac ullamcorper dui tristique. Nullam blandit vel justo sit amet luctus. Proin vitae consectetur odio, eget pharetra elit.
            </p>
          </Grid>
        </Grid>
      </section>
    </div>
  )
}